import { useState } from 'react';
import './EdiPreviewModal.css';

function downloadFile(filename, content) {
  const blob = new Blob([content], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export default function EdiPreviewModal({ files, onClose }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const activeFile = files[activeIndex];
  console.log('[EdiPreviewModal] rendering, files:', files?.length, 'activeFile:', activeFile?.filename);

  return (
    <div className="edi-backdrop">
      <div className="edi-modal">

        {/* Header */}
        <div className="edi-header">
          <div className="edi-header-left">
            <div className="edi-header-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="16 18 22 12 16 6" />
                <polyline points="8 6 2 12 8 18" />
              </svg>
            </div>
            <div>
              <h2 className="edi-title">EDI Preview</h2>
              <p className="edi-subtitle">{activeFile.filename}</p>
            </div>
          </div>
          <button className="edi-close-btn" onClick={onClose} aria-label="Close">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        {/* Tabs — only when multiple files (mixed 837P + 837I batch) */}
        {files.length > 1 && (
          <div className="edi-tabs">
            {files.map((f, i) => (
              <button
                key={i}
                className={`edi-tab ${i === activeIndex ? 'active' : ''}`}
                onClick={() => setActiveIndex(i)}
              >
                {f.formType}
                <span className="edi-tab-count">{f.claimCount} claim{f.claimCount !== 1 ? 's' : ''}</span>
              </button>
            ))}
          </div>
        )}

        {/* Code area */}
        <div className="edi-body">
          <pre className="edi-code">{activeFile.ediContent}</pre>
        </div>

        {/* Footer */}
        <div className="edi-footer">
          <button className="edi-btn-close" onClick={onClose}>
            Close
          </button>
          <button
            className="edi-btn-download"
            onClick={() => downloadFile(activeFile.filename, activeFile.ediContent)}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            Download {activeFile.filename}
          </button>
        </div>

      </div>
    </div>
  );
}
